/*
 * constants for the entire react app are stored here
<<<<<<< HEAD
 * use a constant in the case that any plain text needs to be rendered that is not served from the database,
 * or to set a global constanst for values used consistently throught he app
=======
 * set global constanst for values used consistanly throught he app
>>>>>>> f7e91ca04a10d4b351671da626383f0fea6da1ca
 */

/*
 * breakpoinst const values align with our breakpoint mixin used in assets/_mixins.scss
 */
export const BREAKPOINT = {
	DESKTOP: 1601,
	LAPTOP: 1281,
	LB: 1024,
	LARGE_TABLET: 992,	
	TABLET: 767,
	MOBILE_LANDSCAPE: 550,
	MOBILE: 386
};



// WEBPACK FOOTER //
// ./src/app-lang.js